// src/App.js
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import Navbar from "./pages/Navbar";
import Home from "./components/Home";
import Footer from "./pages/Footer";
import ScrollToTop from "./components/ScrollToTop";
import About from "./components/About";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 800,    
      once: true,
      offset: 100,
    });
    AOS.refresh();
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
